import React from 'react';
import { defineChipColor } from '../../helpers/chipColor';
import { observer } from 'mobx-react-lite';
import { doChipStore } from '../../store/doChipStore';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store';
import { abbreviateNumber } from '@pascal/pascal-core';

const ChipOnTable = observer(({
  allChipsTypes,
  type,
  modelType,
  columnChips,
  child = () => {
  },
}) => {
  const { activeFreeBet } = freeBetStore;

  return (
    <>
      {allChipsTypes?.includes(modelType ? modelType : type) && columnChips[type] ? (
        <div
          className={`chip-block-hover ${`${abbreviateNumber(columnChips[type])}`.length > 2 ? 'long' : ''} ${activeFreeBet.id ? 'free-chip' : defineChipColor(
            columnChips[type],
            doChipStore.quickBets)}`}
          data={type}
          style={{ display: 'flex' }}
        >
          {abbreviateNumber(columnChips[type]) || null}
        </div>
      ) : (
        child()
      )}
    </>
  );
});

export default ChipOnTable;
